import api from "../../services/api";


export interface ProfitabilityReport {
  id: number;
  name: string;
  inbound: number;
  outbound: number;
  net: number;
}

export interface ExemptionNotice {
  level: 'info' | 'warning';
  code: string;
  message: string;
}

export interface ExemptionCategoryResult {
  category: string;
  label: string;
  citation: string;
  cap: number;
  claimed: number;
  exempt: number;
  excess: number;
  cappedOut: boolean;
}

/**
 * Statutory exempt property set aside for the family. Carries its own notices
 * so the reason a figure is what it is can be shown alongside it.
 */
export interface EstateExemption {
  applies: boolean;
  jurisdiction: string | null;
  statute: string | null;
  totalExempt: number;
  totalExcess: number;
  categories: ExemptionCategoryResult[];
  notices: ExemptionNotice[];
}

export interface SummaryData {
  /** Gross estate: every asset, including those already disposed of. */
  estateValue: number;
  /** The gross less anything that has left the estate. */
  remainingEstateValue?: number;
  /** What has left it. Always the gross less the remaining value. */
  distributedEstateValue?: number;
  totalAssets: number;
  totalLiabilities: number;
  totalInboundCashflow: number;
  totalOutboundCashflow: number;
  assetProfitability?: ProfitabilityReport[];
  liabilityProfitability?: ProfitabilityReport[];
  exemption?: EstateExemption;
  probateEstateValue?: number;
}

export const getSummary = async (estateId: string): Promise<SummaryData> => {
  const response = await api.get(`/summary/${estateId}`);
  return response.data;
};
